import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApimSubscriptionInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.API_URL)) {
      return next.handle(request);
    }

    const requestWithSubscriptionKey = request.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': environment.APIM_SUBSCRIPTION_KEY,
      },
    });

    return next.handle(requestWithSubscriptionKey);
  }
}
